export default __webpack_public_path__ + "static/media/Carta.9a591130.png";